export default __webpack_public_path__ + "static/lauburu-0d6410e56c5330adfc30216568a46449.png";